// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__37Z7d","Div":"CustomFadeBox_Div__7GwyW","LargeDiv":"CustomFadeBox_LargeDiv__3FL7i"};